/* eslint-disable no-undef */
'use strict';

function _awaitAsyncGenerator(value) { return new _AwaitValue(value); }

function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }

function _AsyncGenerator(gen) { var front, back; function send(key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; if (back) { back = back.next = request; } else { front = back = request; resume(key, arg); } }); } function resume(key, arg) { try { var result = gen[key](arg); var value = result.value; var wrappedAwait = value instanceof _AwaitValue; Promise.resolve(wrappedAwait ? value.wrapped : value).then(function (arg) { if (wrappedAwait) { resume(key === "return" ? "return" : "next", arg); return; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: true }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: false }); break; } front = front.next; if (front) { resume(front.key, front.arg); } else { back = null; } } this._invoke = send; if (typeof gen.return !== "function") { this.return = undefined; } }

if (typeof Symbol === "function" && Symbol.asyncIterator) { _AsyncGenerator.prototype[Symbol.asyncIterator] = function () { return this; }; }

_AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); };

_AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); };

_AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };

function _AwaitValue(value) { this.wrapped = value; }

function _asyncIterator(iterable) { var method; if (typeof Symbol !== "undefined") { if (Symbol.asyncIterator) { method = iterable[Symbol.asyncIterator]; if (method != null) return method.call(iterable); } if (Symbol.iterator) { method = iterable[Symbol.iterator]; if (method != null) return method.call(iterable); } } throw new TypeError("Object is not async iterable"); }

const fetch = require('node-fetch');

const merge = require('merge-options');

const {
  URL,
  URLSearchParams
} = require('iso-url');

const global = require('./globalthis');

const TextDecoder = require('./text-encoder');

const Request = global.Request;
const AbortController = global.AbortController;

class TimeoutError extends Error {
  constructor() {
    super('Request timed out');
    this.name = 'TimeoutError';
  }

}

class HTTPError extends Error {
  constructor(response) {
    super(response.statusText);
    this.name = 'HTTPError';
    this.response = response;
  }

}

const timeout = (promise, ms, abortController) => {
  if (ms === undefined) {
    return promise;
  }

  return new Promise((resolve, reject) => {
    const timeoutID = setTimeout(() => {
      reject(new TimeoutError());

      if (AbortController) {
        abortController.abort();
      }
    }, ms);
    promise.then(resolve).catch(reject).then(() => {
      clearTimeout(timeoutID);
    });
  });
};

const defaults = {
  throwHttpErrors: true,
  credentials: 'same-origin',
  transformSearchParams: p => p
};
/**
 * @typedef {Object} APIOptions - creates a new type named 'SpecialType'
 * @prop {any} [body] - Request body
 * @prop {string} [method] - GET, POST, PUT, DELETE, etc.
 * @prop {string} [base] - The base URL to use in case url is a relative URL
 * @prop {Headers|Record<string, string>} [headers] - Request header.
 * @prop {number} [timeout] - Amount of time until request should timeout in ms.
 * @prop {AbortSignal} [signal] - Signal to abort the request.
 * @prop {URLSearchParams|Object} [searchParams] - URL search param.
 * @prop {string} [credentials]
 * @prop {boolean} [throwHttpErrors]
 * @prop {function(URLSearchParams): URLSearchParams } [transformSearchParams]
 * @prop {function(any): any} [transform] - When iterating the response body, transform each chunk with this function.
 * @prop {function(Response): Promise<void>} [handleError] - Handle errors
 */

class HTTP {
  /**
   *
   * @param {APIOptions} options
   */
  constructor(options = {}) {
    /** @type {APIOptions} */
    this.opts = merge(defaults, options); // connect internal abort to external

    if (AbortController) {
      this.abortController = new AbortController();

      if (this.opts.signal) {
        this.opts.signal.addEventListener('abort', () => {
          this.abortController.abort();
        });
      }

      this.opts.signal = this.abortController.signal;
    }
  }
  /**
   * Fetch
   *
   * @param {string | URL | Request} resource
   * @param {APIOptions} options
   * @returns {Promise<Response>}
   */


  async fetch(resource, options = {}) {
    /** @type {APIOptions} */
    const opts = merge(this.opts, options); // validate resource type

    if (typeof resource !== 'string' && !(resource instanceof URL || resource instanceof Request)) {
      throw new TypeError('`resource` must be a string, URL, or Request');
    } // validate resource format and normalize with prefixUrl


    if (opts.base && typeof opts.base === 'string' && typeof resource === 'string') {
      if (resource.startsWith('/')) {
        throw new Error('`resource` must not begin with a slash when using `base`');
      }

      if (!opts.base.endsWith('/')) {
        opts.base += '/';
      }

      resource = opts.base + resource;
    } // TODO: try to remove the logic above or fix URL instance input without trailing '/'


    const url = new URL(resource, opts.base);

    if (opts.searchParams) {
      url.search = opts.transformSearchParams(new URLSearchParams(opts.searchParams));
    }

    const response = await timeout(fetch(url, opts), opts.timeout, this.abortController);

    if (!response.ok && opts.throwHttpErrors) {
      if (opts.handleError) {
        await opts.handleError(response);
      }

      throw new HTTPError(response);
    }

    return response;
  }
  /**
   * @param {string | URL | Request} resource
   * @param {APIOptions} options
   * @returns {Promise<Response>}
   */


  post(resource, options = {}) {
    return this.fetch(resource, merge(this.opts, options, {
      method: 'POST'
    }));
  }
  /**
   * @param {string | URL | Request} resource
   * @param {APIOptions} options
   * @returns {Promise<Response>}
   */


  get(resource, options = {}) {
    return this.fetch(resource, merge(this.opts, options, {
      method: 'GET'
    }));
  }
  /**
   * @param {string | URL | Request} resource
   * @param {APIOptions} options
   * @returns {Promise<Response>}
   */


  put(resource, options = {}) {
    return this.fetch(resource, merge(this.opts, options, {
      method: 'PUT'
    }));
  }
  /**
   * @param {string | URL | Request} resource
   * @param {APIOptions} options
   * @returns {Promise<Response>}
   */


  delete(resource, options = {}) {
    return this.fetch(resource, merge(this.opts, options, {
      method: 'DELETE'
    }));
  }
  /**
   * @param {string | URL | Request} resource
   * @param {APIOptions} options
   * @returns {Promise<Response>}
   */


  options(resource, options = {}) {
    return this.fetch(resource, merge(this.opts, options, {
      method: 'OPTIONS'
    }));
  }
  /**
   * @param {string | URL | Request} resource
   * @param {APIOptions} options
   * @returns {Promise<ReadableStream<Uint8Array>>}
   */


  async stream(resource, options = {}) {
    const res = await this.fetch(resource, merge(this.opts, options));
    return res.body;
  }
  /**
   * @param {string | URL | Request} resource
   * @param {APIOptions} options
   * @returns {AsyncGenerator<Uint8Array, void, any>}
   */


  iterator(resource, options = {}) {
    var _this = this;

    return _wrapAsyncGenerator(function* () {
      const res = yield _awaitAsyncGenerator(_this.fetch(resource, merge(_this.opts, options)));
      const it = streamToAsyncIterator(res.body);

      if (!isAsyncIterator(it)) {
        throw new Error('Can\'t convert fetch body into a Async Iterator:');
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;

      var _iteratorError;

      try {
        for (var _iterator = _asyncIterator(it), _step, _value; _step = yield _awaitAsyncGenerator(_iterator.next()), _iteratorNormalCompletion = _step.done, _value = yield _awaitAsyncGenerator(_step.value), !_iteratorNormalCompletion; _iteratorNormalCompletion = true) {
          const chunk = _value;
          yield chunk;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            yield _awaitAsyncGenerator(_iterator.return());
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    })();
  }
  /**
   * @param {string | URL | Request} resource
   * @param {APIOptions} options
   * @returns {AsyncGenerator<Object, void, any>}
   */


  ndjson(resource, options = {}) {
    const source = ndjson(this.iterator(resource, merge(this.opts, options)));

    if (options.transform) {
      return _wrapAsyncGenerator(function* () {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;

        var _iteratorError2;

        try {
          for (var _iterator2 = _asyncIterator(source), _step2, _value2; _step2 = yield _awaitAsyncGenerator(_iterator2.next()), _iteratorNormalCompletion2 = _step2.done, _value2 = yield _awaitAsyncGenerator(_step2.value), !_iteratorNormalCompletion2; _iteratorNormalCompletion2 = true) {
            const chunk = _value2;
            yield options.transform(chunk);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              yield _awaitAsyncGenerator(_iterator2.return());
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      })();
    }

    return source;
  }

}
/**
 * Parses NDJSON chunks from an iterator
 *
 * @param {AsyncGenerator<Uint8Array, void, any>} source
 * @returns {AsyncGenerator<Object, void, any>}
 */


const ndjson = /*#__PURE__*/function () {
  var _ref2 = _wrapAsyncGenerator(function* (source) {
    const decoder = new TextDecoder();
    let buf = '';
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;

    var _iteratorError3;

    try {
      for (var _iterator3 = _asyncIterator(source), _step3, _value3; _step3 = yield _awaitAsyncGenerator(_iterator3.next()), _iteratorNormalCompletion3 = _step3.done, _value3 = yield _awaitAsyncGenerator(_step3.value), !_iteratorNormalCompletion3; _iteratorNormalCompletion3 = true) {
        const chunk = _value3;
        buf += decoder.decode(chunk, {
          stream: true
        });
        const lines = buf.split(/\r?\n/);

        for (let i = 0; i < lines.length - 1; i++) {
          const l = lines[i].trim();

          if (l.length > 0) {
            yield JSON.parse(l);
          }
        }

        buf = lines[lines.length - 1];
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          yield _awaitAsyncGenerator(_iterator3.return());
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    buf += decoder.decode();
    buf = buf.trim();

    if (buf.length !== 0) {
      yield JSON.parse(buf);
    }
  });

  return function ndjson(_x) {
    return _ref2.apply(this, arguments);
  };
}();

const streamToAsyncIterator = function streamToAsyncIterator(source) {
  if (isAsyncIterator(source)) {
    return source;
  }

  const reader = source.getReader();
  return {
    next() {
      return reader.read();
    },

    return() {
      reader.releaseLock();
      return {};
    },

    [Symbol.asyncIterator]() {
      return this;
    }

  };
};

const isAsyncIterator = obj => {
  return typeof obj === 'object' && obj !== null && // typeof obj.next === 'function' &&
  typeof obj[Symbol.asyncIterator] === 'function';
};

HTTP.HTTPError = HTTPError;
HTTP.TimeoutError = TimeoutError;
HTTP.ndjson = ndjson;
HTTP.streamToAsyncIterator = streamToAsyncIterator;
module.exports = HTTP;